// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: icon('ic_analytics'),
  },
  {
    title: 'conversions',
    path: '/dashboard/conversions',
    icon: icon('ic_user'),
  },
  {
    title: 'payouts',
    path: '/dashboard/payouts',
    icon: icon('ic_banking'),
  }
];

export default navConfig;
